import { TickerInfo } from './model';
import { validInfo } from './storage';
export async function lookupTicker(ticker: string, signal?: AbortSignal): Promise<TickerInfo> {
  const response = await fetch(`/api/trading-checklist/tickers/${encodeURIComponent(ticker)}`, { credentials: 'same-origin', signal });
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.error === 'string' ? data.error : 'Ticker lookup failed. Try again.');
  if (!validInfo(data) || data.ticker !== ticker) throw new Error('Ticker lookup returned incomplete data. Try again.');
  return data;
}
